import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['b','i','em','strong','a','p','br','ul','ol','li','div','span','h1','h2','h3','h4','table','tr','td','th','thead','tbody','img','hr','blockquote','pre','code'],
  ALLOWED_ATTR: ['href','target','rel','src','alt','style','class','width','height','colspan','rowspan'],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeHtml(dirty) {
  return DOMPurify.sanitize(dirty, SANITIZE_CONFIG);
}

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Country flag — delegated to consolidated countries module.
// Kept here for backward compatibility with existing import sites.
import { countryFlag } from "./countries";

export function getCountryFlag(country) {
  if (!country) return null;
  return countryFlag(country) || null;
}

/**
 * Format distance with appropriate units based on country.
 * UK/US use miles; everywhere else uses km.
 */
export function formatDistance(distanceKm, country) {
  if (!distanceKm || distanceKm >= 900) return null;
  const c = (country || "").toLowerCase().trim();
  const useMiles = c.includes("uk") || c.includes("united kingdom") || c.includes("united states") || c === "us" || c === "usa";
  if (useMiles) {
    return `${(distanceKm * 0.621371).toFixed(1)} miles`;
  }
  return `${distanceKm.toFixed(1)} km`;
}

/**
 * Format driving duration for display, with the road distance when known.
 * Under 60 min: "X min by car". 60+: "Xh Ym by car". With roadKm:
 * "28 min by car (31.1 km)", so the drive is never read against the
 * straight-line distance shown next to it.
 * Returns null when minutes is null/undefined.
 */
export function formatDrivingTime(minutes, roadKm, country) {
  if (minutes == null) return null;
  const road = roadKm != null && roadKm > 0 ? formatDistance(roadKm, country) : null;
  const tail = road ? ` (${road})` : "";
  if (minutes < 60) return `${minutes} min by car${tail}`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m by car${tail}`;
}
